import React from 'react';
import GenericPage from './GenericPage';
import Report from '../components/Report';
import { useNavigate } from "react-router-dom";

const LabTestsPage = () => {

    const navigate = useNavigate();

    const labTestsData = [
        {
            'Número de consecutivo':1,
            'Paciente': '1012345678',
            'Prueba': 'Nombre prueba',
            'Laboratorio': 'Laboratorio 1',
            'Estado': 'Pendiente'
        }
    ];

    const showProgressPage = () => {
      navigate("/lab-tests-progress");
    }

    return (
      <GenericPage active="Pruebas de Laboratorio">
        <div className="report-header">
          <div className="report-title">
            <h1>Pruebas de Laboratorio</h1>
          </div>
        </div>
        <Report
          data={labTestsData}
          details={true}
          onDetailClick={showProgressPage}
        />
      </GenericPage>
    );
}

export default LabTestsPage;
